<template>
<div class="questions-wrapper" style="position: relative;top: 27px;">
  <div class="section__inner">
    <container>
      <div class="list-header">
        <div class="subpage-header__title section__title">
          <span class="color-light-green">Fill the Form</span> Add Your Movie !
        </div>
        <p class="subpage-header__text">Every year more than 2 million people select us for movie selections. Fill the Form , join us!</p>
      </div>
      <div class="subpage-accordion text-left col-xl-10 offset-xl-1" style="align-items: flex-start;">
      <form id="myForm"  @submit.prevent="submitForm">
        <div class="login-box">
          <h3 class="login-box__title">ADD MOVIE<br> <span
            class="color-light-green">REQUEST FORM</span></h3>
          <v-input placeholder="Movie Name" v-model="dormName" v-on:keyup.native="saveForm"/>
          <label for="password" v-if="emptyDormName" class="myValidationText">Can not be leave empty!</label> 
          <div class="login-box__left">
            <!-- <v-input placeholder="Yurt Kapasitesi" v-model="dormCapacity" /> -->
             <!-- <label for="password" type="tel" v-if="emptyDormCapacity" class="myValidationText" required>Can not be leave empty!</label> -->


            <v-select v-if="city_name === 'Select Genre' || city_name === null || city_name ===''" :options="cities" placeholder="Select Genre"  @onselect="selectCity"/>
            <VueSelectTempCity1 v-else :options="cities" placeholder="Select Genre"  @onselect="selectCity"/>
            <!-- <label for="password" v-if="emptyUniversity" class="myValidationText">Can not be leave empty!</label> -->
            <!-- <select-box :options="cities" :title="city_name" @onselect="selectCity"/> -->
          </div>
          <div class="login-box__left">
             <!-- <VueSelect2 v-if="district_name === 'Select Genre' && city_name !='Select Genre'" :options="districts" placeholder='Select Genre' @onselect="selectDistrict"/> -->
            <VueSelectTempDistrict v-if="districtEnabled && district_name !='Select Genre'" placeholder="Select Genre" :options="districts"  @onselect="selectDistrict"/>
            <SelectBox2 v-else myplaceholder="Select Genre" :options="districts" :title="district_name" @onselect="selectDistrict" disabled/>
          </div>
          <v-input placeholder="Authorized People Name" v-model="memberName" v-on:keyup.native="saveForm"/>
          <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label> 
          <!-- <div class="login-box__left"> -->
            <!-- <v-input placeholder="Authorized People Phone" v-model="memberPhone"/> -->
            <VueInputRestricted  placeholder="Telephone" v-on:keyup.native="saveForm" v-model="memberPhone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Phone number must be 11 digits!</label>            
            <!--             <v-input placeholder="Telephone" v-model="dormPhone"/>
             <label for="phone" v-if="emptyPhone2" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone2" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone2" class="myValidationText">Phone number must be 11 digits!</label> 
          </div> -->
          <v-input placeholder="E-Posta Adresi" v-model="email" v-on:keyup.native="saveForm"/>
          <!-- <label for="password" type="tel" v-if="emptyDormCapacity" class="myValidationText" required>Can not be leave empty!</label>  -->

          <v-input placeholder="Yurt Kapasitesi" v-model="dormCapacity" v-on:keyup.native="saveForm"/>
<label for="password" v-if="emptyDormCapacity" class="myValidationText">Can not be leave empty!</label> 

          <v-input placeholder="Adres" v-model="dormAddress" v-on:keyup.native="saveForm"/>
           <!-- <label for="password" v-if="emptyDormAddress" class="myValidationText">Can not be leave empty!</label>  -->

          <div class="check-wrapper smart-map">
            <div class="check-wrapper__item"><label class="container2" style="width: 100%;margin-bottom: 50px;">
              <div class="check"><input type="checkbox" style="width: auto;"><span class="checkmark"></span><span
                class="name"> I want to aware of news and campaings via email. </span>
              </div>
            </label></div>
            <!--             <div class="check-wrapper__item">
              <label class="container2" style="width: 100%; margin-bottom: 50px;">
                <div class="check"><input type="checkbox" style="width: auto;">
                  <span class="checkmark"></span>
                  <span class="name"> I want to aware of news and campaings via email. </span>
                </div>
              </label></div> -->
          </div>

          <v-button
            class="green fw shadow-none login-box__submit"
            title="GÖNDER"
            style="margin-top: 0"
            @click.native="submitForm()"
            v-if="sendEnabled"
          />
          <v-button
            class="green fw shadow-none login-box__submit"
            title="GÖNDERİYOR"
            style="margin-top: 0"
            v-if="!sendEnabled"
          />
        </div>
        </form>
        <div class="subpage-accordion__wrapper">
          <div class="subpage-accordion__item"
               :class="{ active : $index === currentAccordion }"
               v-for="(accordion, $index) in accordions"
               :key="accordion.id">
            <div class="subpage-accordion__header" @click="toggle($index)">
              <div class="subpage-accordion__title">
                {{ accordion.title }}
              </div>
              <span class="subpage-accordion__caret">
                  <svg-icon type="icon-arrow-down"/>
                </span>
            </div>
            <slide-up-down :duration="600" :active="$index === currentAccordion">
              <div class="subpage-accordion__cnt" v-html="accordion.text"></div>
            </slide-up-down>
          </div>
        </div>
      </div>
    </container>
  </div>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content" style="height: 250px">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >WE GOT YOUR REQUEST!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Thank you for your interrest.</span></p>
      <p ><span class= "mycolorBlue">Our friend will be in contact with you soon.</span></p>
    </div>
     </div>
</div>
</Modal2>  
</div>
</template>

<script>
import Modal2 from '@/components/Modal2'
import SelectBox2 from '@/components/SelectBox2'
import VueInputRestricted from '@/components/VueInputRestricted'
import VueSelectTempCity1 from '@/components/VueSelectTempCity1'
import VueSelectTempDistrict from '@/components/VueSelectTempDistrict'
import VueSelect2 from '@/components/VueSelect2'
import axios from 'axios'
export default {
  name: 'Advertisement',
  components: {
    Modal2, SelectBox2, VueInputRestricted, VueSelectTempCity1, VueSelectTempDistrict, VueSelect2
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Add Movie',
      meta: [
         { vmid: 'description', name: 'description', content: 'Every year more than 2 million people select us for movie selections. Fill the Form , join us!' },
         { vmid: 'keywords', name: 'keywords', content: 'holywood skyline, movie guide, movie prices, movie record, special movies' }
       ],      
      link: [
        { rel: 'canonical', href: window.location.origin + '/yurdumu-ekle/' }
      ]       
    }
  },   
  data () {
    return {
      sendEnabled: true,
      cities: [],
      districts: [],
      city_name: 'Select Genre',
      district_name: 'Select Subgenre',
      districtEnabled: false,
      showSuccessMessage: false,
      dormPhone: '',
      dormAddress: '',
      dormMember: '',
      dormName: '',
      memberPhone: '',
      email: '',
      memberName: '',
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      shortPhone: false,
      falsePhone: false,
      emptyEmail: false,
      shortPhone2: false,
      falsePhone2: false,
      emptyDormName: false,
      emptyDormAddress: false,
      emptyPhone2: false,
      emptyDormCapacity: false,
      description1: null,
      name1: null,
      first_name: null,
      last_name: null,
      twitter_user: null,
      universities: null,
      faculties: null,      
      url: '',
      showModal: false,
      favorites: [],
      email: '',
      password: '',      
      showShareButtons: false,
      isFavorite: false,
      isShare: false,
      isNumberShow: false,
      isMessage: false,
      hasError: true,      
      currentAccordion: null,
      accordions: [
        {
          id: 0,
          title: 'Yurt Ayrıntı Sayfası (Özel Üyelik)',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
            'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
            'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
            'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
            ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
            'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
            'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
            'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>'
        },
        {
          id: 1,
          title: 'İl Sponsorluğu',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
            'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
            'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
            'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
            ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
            'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
            'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
            'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>'
        },
        {
          id: 2,
          title: 'Ana Sayfa Reklamları',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
            'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
            'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
            'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
            ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
            'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
            'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
            'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>'
        },
        {
          id: 3,
          title: 'Üniversite Tanıtım Sayfası Reklamları',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
            'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
            'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
            'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
            ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
            'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
            'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
            'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>'
        }
      ]
    }
  },
  methods: {
    toggle (index) {
      if (index === this.currentAccordion) {
        this.currentAccordion = null
      } else {
        this.currentAccordion = index
      }
    },
    saveForm() {
      window.localStorage.setItem('dormName', this.dormName)       
      window.localStorage.setItem('dormAddress', this.dormAddress) 
      window.localStorage.setItem('memberName', this.memberName)      
      window.localStorage.setItem('memberPhone', this.memberPhone)      
      window.localStorage.setItem('username', this.name)
      window.localStorage.setItem('dormMail', this.email)
      window.localStorage.setItem('phone1', this.phone)
    },
    getCities() {
          var self = this
      //daxios.get('/site/cities/cities')
            axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
     selectDistrict (opt) {
      this.district_name = opt.name
      window.localStorage.setItem('district_id', opt.id)
      window.localStorage.setItem('district_name', opt.name)
    },   
    selectCity (opt) {
      this.districtEnabled = true
    //  this.university_id = opt.id
      this.city_name = opt.name
      window.localStorage.setItem('city_name', opt.name)
      window.localStorage.setItem('city_slug', opt.slug)   
      let self = this
      axios.get(`/site/cities/${opt.slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
        .catch(e => {
          this.errors.push(e)
        }) 
    },    
    closeModal2() {
      this.showSuccessMessage = false
    },    
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
},     
    submitForm () {    
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.falseEmail2 = false
      this.falsePhone2 = false
      this.shortPhone2 = false      
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyDormName = false
      this.emptyDormAddress = false
      const verifiedMail = this.validateEmail(this.email)
      var self = this
                

      if(!this.email) {
        this.emptyEmail = true
      } else if(this.email &&!verifiedMail) {
        this.falseEmail = true
      }
      if(!this.memberName) {
        this.emptyName = true
      }
      if(!this.memberPhone) {
        this.emptyPhone = true
      }

      if(this.memberPhone && !this.memberPhone.startsWith("0")) {
        this.falsePhone = true
      }      

      if(this.memberPhone && !this.falsePhone && this.memberPhone.length != 11) {
        this.shortPhone = true
      }

      if(!this.dormPhone) {
        this.emptyPhone2 = true
      }

      if(this.dormPhone && !this.dormPhone.startsWith("0")) {
        this.falsePhone2 = true
      }      

      if(this.dormPhone && !this.falsePhone2 && this.dormPhone.length != 11) {
        this.shortPhone2 = true
      }

      if(!this.dormName || this.dormName == 'null') {
        this.emptyDormName = true
      }

      if(!this.dormCapacity || this.dormCapacity == 'null') {
        this.emptyDormCapacity = true
      }

      
       if(!this.dormAddress || this.dormAddress == 'null') {
        this.emptyDormAddress = true
      }   

      let dene = this.dormCapacity

if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyDormName) {
        let self = this
        this.sendEnabled = false
         axios.post(`/site/dorm/pre_register`, {
          member: this.memberName,
          name: this.dormName,
          capacity: this.dormCapacity,
          email: this.email,
          phone: this.memberPhone,
          mobile_phone: this.memberPhone,
          address: this.dormAddress
        })
          .then(response => {
            this.sendEnabled = true
            if (response.status === 200 || response.status === 201) {
              document.getElementById('myForm').reset()
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
            // console.log('Hata Mesajı: ' + error.response);
        }})  
      }
    }   
  },
  created() {
   // this.getCities()
      if (!window.localStorage.getItem('dormName') || window.localStorage.getItem('dormName') === '' || window.localStorage.getItem('dormName') === 'null') {
        this.dormName = ''
      } else {
        this.dormName = window.localStorage.getItem('dormName')
      }   
      if (!window.localStorage.getItem('dormMail') || window.localStorage.getItem('dormMail') === '' || window.localStorage.getItem('dormMail') === 'null') {
        this.email = ''
      } else {
        this.email = window.localStorage.getItem('dormMail')
      }
      if (!window.localStorage.getItem('memberName') || window.localStorage.getItem('memberName') === '' || window.localStorage.getItem('memberName') === 'null') {
        this.memberName = ''
      } else {
        this.memberName = window.localStorage.getItem('memberName')
      }
      if (!window.localStorage.getItem('dormAddress') || window.localStorage.getItem('dormAddress') === '' || window.localStorage.getItem('dormAddress') === 'null') {
        this.dormAddress = ''
      } else {
        this.dormAddress = window.localStorage.getItem('dormAddress')
      }      
      if (!window.localStorage.getItem('memberPhone') || window.localStorage.getItem('memberPhone') === '' || window.localStorage.getItem('memberPhone') === 'null') {
        this.memberPhone = ''
      } else { 
        this.memberPhone = window.localStorage.getItem('memberPhone')
      }              
      if (!window.localStorage.getItem('username') || window.localStorage.getItem('username') === '' || window.localStorage.getItem('username') === 'null') {
        this.name = ''
      } else {
        this.name = window.localStorage.getItem('username')
      }
      if (!window.localStorage.getItem('phone1') || window.localStorage.getItem('phone1') === '' || window.localStorage.getItem('phone1') === 'null') {
        this.phone = ''
      } else {
        this.phone = window.localStorage.getItem('phone1')
        this.university_id = window.localStorage.getItem('university_id')
        this.faculty_id = window.localStorage.getItem('faculty_id')
      }
      if (!window.localStorage.getItem('city_name') || window.localStorage.getItem('city_name') === '' || window.localStorage.getItem('universitcity_namey_name') === 'null') {
        this.city_name = 'Select Genre'
        this.districtEnabled = false
      } else {
        this.districtEnabled = true
        let self = this
        let city_slug = window.localStorage.getItem('city_slug')
        this.city_name = window.localStorage.getItem('city_name')
        axios.get(`/site/cities/${city_slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
      }

      if (!window.localStorage.getItem('district_name') || window.localStorage.getItem('district_name') === 'null' || window.localStorage.getItem('district_name') === 'null') {
        this.district_name = 'Select Subgenre'
      } else {
        this.district_name = window.localStorage.getItem('district_name')
      }    
  }
}
</script>

<style lang="scss">
.name {
  width: 90%;
  position: relative;
  top: -1px;
  font-size: 14px;
  float: right;
  left: -10px;
}

</style>
